import type { VideoAbVariant } from "@/lib/useVideoAbSlot";

/**
 * Postgres jsonb via Worker/Hyperdrive may arrive as a JSON string in API responses.
 * Coerce before admin pages call .filter() / .map() on variants.
 */
export function parseVideoAbVariants(raw: unknown): VideoAbVariant[] {
  if (Array.isArray(raw)) return raw as VideoAbVariant[];
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (!trimmed) return [];
    try {
      const parsed: unknown = JSON.parse(trimmed);
      return Array.isArray(parsed) ? (parsed as VideoAbVariant[]) : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function normalizeVideoAbSlot<T extends { variants?: unknown }>(
  slot: T,
): T & { variants: VideoAbVariant[] } {
  return { ...slot, variants: parseVideoAbVariants(slot.variants) };
}